<template>

        <v-select
                prepend-icon="view_stream"
                :items="items"
                v-model="item"
                :item-text="'Desc'"
                :item-value="'Id'"
                :label="$t('afip.factura.labels.MonId')"
                :loading="loading"
                :error="hasInputErrors('MonId')"
                :error-messages="getInputErrors('MonId')"
                color="secondary"
                item-color="secondary"
                :clearable="clearable"
                :multiple="multiple"
                :chips="chips"
                :solo="solo"
        ></v-select>

</template>

<script>

    import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'
    import AfipProvider from "@/modules/afip/providers/AfipProvider";


    export default {
        name: "TipoMonedaCombobox",
        mixins: [InputErrorsByProps, RequiredRule],
        props:{
            value: {type: [String, Array]},
            clearable: {type:Boolean, default: false},
            multiple: {type:Boolean, default: false},
            solo: {type:Boolean, default: false},
            chips: {type:Boolean, default: false}
        },
        data() {
            return {
                items: ['PES','DOL'],
                loading: false
            }
        },
        computed: {
           item: {
                get() { return this.value },
                set(val) {this.$emit('input', val)}
            }
        },
      mounted() {
        this.fetch()
      },
      methods: {
        validate() {
          return this.$refs.form.validate()
        },
        fetch() {
          this.loading = true
          AfipProvider.getTipoMonedas().then(r => {
            this.items = r.data.getTipoMonedas
          }).catch(err => console.error(err))
              .finally(() => this.loading = false)
        }

      }
    }
</script>

<style scoped>

</style>

